// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    GetIntelligentPartnerTaskFinishRecordsQuery,
    BaseResponseListIntelligentPartnerTaskFinishRecordFoundResponse,
    PostIntelligentPartnerTaskFinishRecordsBody,
    BaseResponseIntelligentPartnerTaskFinishRecordFoundResponse,
} from '../types';

/**
 * 历史学习数据列表
 *
 * @export
 * @tags 智能陪练-历史学习数据
 * @link [GET] /intelligentPartnerTaskFinishRecords
 */
export function getIntelligentPartnerTaskFinishRecords(): Promise<BaseResponseListIntelligentPartnerTaskFinishRecordFoundResponse>;
export function getIntelligentPartnerTaskFinishRecords(
    options: ApiOptions<never, GetIntelligentPartnerTaskFinishRecordsQuery>
): Promise<BaseResponseListIntelligentPartnerTaskFinishRecordFoundResponse>;
export function getIntelligentPartnerTaskFinishRecords(
    options?: ApiOptions<never, GetIntelligentPartnerTaskFinishRecordsQuery>
): Promise<BaseResponseListIntelligentPartnerTaskFinishRecordFoundResponse> {
    return request<never, never, GetIntelligentPartnerTaskFinishRecordsQuery>(
        '/intelligentPartnerTaskFinishRecords',
        {
            ...options,
            method: 'get',
            __$requestCalleeName: 'getIntelligentPartnerTaskFinishRecords',
        }
    );
}

/**
 * save
 *
 * @export
 * @tags 智能陪练-历史学习数据
 * @link [POST] /intelligentPartnerTaskFinishRecords
 */
export function postIntelligentPartnerTaskFinishRecords(
    data: PostIntelligentPartnerTaskFinishRecordsBody
): Promise<BaseResponseIntelligentPartnerTaskFinishRecordFoundResponse>;
export function postIntelligentPartnerTaskFinishRecords(
    data: PostIntelligentPartnerTaskFinishRecordsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseIntelligentPartnerTaskFinishRecordFoundResponse>;
export function postIntelligentPartnerTaskFinishRecords(
    data: PostIntelligentPartnerTaskFinishRecordsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseIntelligentPartnerTaskFinishRecordFoundResponse> {
    return request<PostIntelligentPartnerTaskFinishRecordsBody, never, never>(
        '/intelligentPartnerTaskFinishRecords',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postIntelligentPartnerTaskFinishRecords',
        }
    );
}

export const meta = [
    {
        tags: ['智能陪练-历史学习数据'],
        path: '/intelligentPartnerTaskFinishRecords',
        method: 'get',
    },
    {
        tags: ['智能陪练-历史学习数据'],
        path: '/intelligentPartnerTaskFinishRecords',
        method: 'post',
    },
];
